import apiClient from "services/axios";

const API = {
  delete: "/api/v1/user-sessions",
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
